import React, { useContext, useMemo } from "react";
import { StoreContext, StoreContextProvider } from "../store/Store.context.js";
import { CartContextProvider } from "../cart/Cart.context.js";
import { ProfileContextProvider } from "../profile/Profile.context.js";
export function Page({ store, useCartContext, renderComponent, children, }) {
    const core = (React.createElement(StoreContextProvider, { store: store },
        React.createElement(ProfileContextProvider, { initialProfile: store.context.profile },
            React.createElement(PageCreator, { renderComponent: renderComponent }, children))));
    if (useCartContext) {
        return (React.createElement(CartContextProvider, { initialCart: store.context.cart }, core));
    }
    return core;
}
export function PageCreator({ renderComponent, children, }) {
    const storeContext = useContext(StoreContext);
    const store = storeContext.store;
    const sections = useMemo(() => {
        const sectionTree = store.sectionTree;
        return {
            header: sectionTree.header.map((s) => (React.createElement(Section, { key: s.name, section: s, renderComponent: renderComponent }))),
            main: sectionTree.main.map((s) => (React.createElement(Section, { key: s.name, section: s, renderComponent: renderComponent }))),
            footer: sectionTree.footer.map((s) => (React.createElement(Section, { key: s.name, section: s, renderComponent: renderComponent }))),
        };
    }, [store, renderComponent]);
    return React.createElement(React.Fragment, null, children(sections));
}
const Section = ({ section, renderComponent }) => {
    return (React.createElement("div", { id: section.name, className: `section${section.cssClass ? ` ${section.cssClass}` : ""}` }, renderComponent(section, section.children.map((s) => (React.createElement(Section, { key: s.name, section: s, renderComponent: renderComponent }))))));
};
